const services = [
  {
    title: "iOS Platform Engineering",
    description:
      "Deep expertise in native iOS development, leveraging platform-specific capabilities to build seamless, responsive, and high-performance applications tailored to modern hardware and OS standards.",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20three%20dimensional%20geometric%20composition%20of%20interconnected%20nodes%20and%20architectural%20wireframe%20structures%20floating%20in%20dark%20space%20warm%20amber%20and%20copper%20tones%20against%20deep%20charcoal%20background%20minimalist%20tech%20aesthetic%20suggesting%20system%20architecture%20and%20scalability%20clean%20precise%20lines%20no%20people%20no%20text%20abstract%20digital%20art&width=800&height=1067&seq=service-arch-mq-01&orientation=portrait",
    wide: true,
  },
  {
    title: "System Architecture & Design",
    description:
      "Scalable and maintainable system architectures built on clean design principles. We structure every codebase for long-term evolvability, testability, and team collaboration.",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20visualization%20of%20speed%20and%20computational%20efficiency%20flowing%20luminous%20data%20streams%20in%20warm%20golden%20and%20copper%20tones%20against%20dark%20gradient%20background%20sleek%20modern%20digital%20aesthetic%20light%20trail%20effects%20suggesting%20rapid%20processing%20and%20optimization%20no%20people%20pure%20abstract%20composition&width=800&height=1067&seq=service-perf-mq-02&orientation=portrait",
    wide: false,
  },
  {
    title: "Quality & Performance",
    description:
      "Rigorous performance optimization, stability engineering, and quality assurance practices that ensure systems remain fast, reliable, and resilient under real-world conditions.",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20minimalist%20composition%20with%20soft%20warm%20golden%20geometric%20shapes%20layered%20translucent%20forms%20suggesting%20interface%20design%20principles%20clean%20modern%20aesthetic%20subtle%20gradient%20transitions%20dark%20sophisticated%20background%20no%20people%20abstract%20digital%20art&width=800&height=1067&seq=service-ux-mq-03&orientation=portrait",
    wide: false,
  },
];

export default function ServicesSection() {
  return (
    <section className="relative bg-background-50 py-20 md:py-28 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="mb-14 md:mb-20">
          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-semibold text-foreground-900 leading-tight">
            What We Do
            <span className="inline-flex items-center justify-center w-8 h-8 md:w-10 md:h-10 align-middle ml-3">
              <i className="ri-flashlight-line text-3xl md:text-4xl text-primary-500"></i>
            </span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className={`relative group overflow-hidden rounded-2xl ${
                service.wide ? "md:col-span-2 md:row-span-2" : ""
              }`}
            >
              <div
                className={`relative w-full ${
                  service.wide ? "aspect-[4/3] md:aspect-auto md:h-full" : "aspect-[3/4]"
                }`}
              >
                <img
                  src={service.image}
                  alt=""
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <h3 className="font-heading text-xl md:text-2xl lg:text-3xl font-semibold text-white mb-2">
                  {service.title}
                </h3>
                <p className="text-sm md:text-base text-white/75 leading-relaxed max-w-lg">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}